/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  Form,
  Button,
  Modal,
  Alert,
  ListGroup,
  Spinner,
} from "react-bootstrap";
import API from "../Utility";
import Search from "../Search";

import { FaTimes } from "react-icons/fa";

export default function EditGroupUsersForm(props) {
  const { project, groupId } = useParams();
  const groupsUrl = `/admin/${project}/users/search`;
  let [availableUsers, setAvailableUsers] = useState([]);
  let [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  let defaultData = { searchText: "", group: groupId, groupStatus: "0" };
  // const [clearSearch, setClearSearch] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showMessages, setShowMessages] = useState(false);
  const [limitUserToOneGroup, setLimitUserToOneGroup] = useState(false);

  async function getLearningCentre(query) {
    const data = await API.get({
      url: query.url,
      params: query.params,
    });
    setLimitUserToOneGroup(
      data &&
        data.config &&
        data.config.general &&
        data.config.general.limitUserToOneGroup === true
    );
    setIsLoading(false);
  }
  useEffect(() => {
    async function initializeData() {
      await getLearningCentre({
        url: `/admin/${project}`,
      });
    }

    initializeData();
  }, []);

  async function getAvailableUsers({ url = groupsUrl, data = defaultData }) {
    setAvailableUsers([]);
    setIsLoading(true);
    const searchResults = await API.post({
      url: url,
      data: data,
    });
    setAvailableUsers(searchResults);
    setIsLoading(false);
  }

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    let isValid = false;
    if (!users || (users && users.length === 0)) {
      isValid = false;
    } else {
      isValid = true;
    }
    if (isValid === false) {
      event.preventDefault();
      event.stopPropagation();
      props.onSubmit(null, {
        message: "Please select at least one",
        status: 3,
      });
    } else {
      event.preventDefault();
      event.stopPropagation();

      saveGroup();
    }
  };

  const addUserToArray = (user, removeUser) => {
    const temp = [...users];
    const handleUsers = (userToAdd) => {
      let userIndex = users.indexOf(userToAdd);
      if (userIndex === -1) {
        temp.push(userToAdd);
        // setClearSearch(true);
      }
      if (userIndex !== -1 && removeUser) {
        temp.splice(userIndex, 1);
      }
    };

    if (Array.isArray(user)) {
      user.forEach(function (u) {
        handleUsers(u);
      });
    } else {
      handleUsers(user);
    }
    setUsers(temp);
    setAvailableUsers([]);
  };

  const saveGroup = async () => {
    await save({
      url: `/admin/${props.project}/groups/${props.group._id}/addUsers`,
      data: { users: users },
    });
  };

  async function save(query) {
    setSubmitting(true);
    const response = await API.post({
      url: query.url,
      data: query.data,
    });
    props.onSubmit(null, response);
    setSubmitting(false);
    if (response) {
      setShowMessages(true);
      setTimeout(() => {
        setShowMessages(false);
      }, 3000);
    } else {
      setShowMessages(false);
    }
  }

  const searchRef = useRef();

  return (
    // <Form noValidate onSubmit={handleSubmit}>
    <>
      <Modal.Body style={{ minHeight: "50vh" }}>
        <h5>Available Users</h5>
        {limitUserToOneGroup ? (
          <p>
            <small>
              Note: Each user may only be a member of a single group. Go to
              Settings &gt; General to change.
            </small>
          </p>
        ) : (
          <></>
        )}
        {/* <Form.Group> */}
        <Search
          placeholder="Search"
          labelKey="displayName"
          options={availableUsers}
          isLoading={isLoading}
          isTypeAhead={true}
          minLength={3}
          delay={450}
          callback={(text) => {
            return getAvailableUsers({
              data: { ...defaultData, searchText: text },
            });
          }}
          onChange={addUserToArray}
          renderMenuItemChildren={(option, props) => (
            <Button
              className="col-md-12 text-left"
              variant="default"
              type={"button"}
              onClick={() => {
                addUserToArray(option);
                searchRef.current.clearInput();
                setTimeout(() => {
                  searchRef.current.focusInput();
                });
              }}
            >
              <span>{option.displayName || option.email}</span>
            </Button>
          )}
          ref={searchRef}
          limitUserToOneGroup={limitUserToOneGroup}
          // clearInput={clearSearch}
        />
        {/* </Form.Group> */}

        {users && users.length > 0 && (
          <>
            <br />
            <h5>Users to Add</h5>
            <ListGroup>
              {users.map((u) => (
                <ListGroup.Item key={u._id}>
                  {u.displayName}
                  <Button
                    style={{ minWidth: "auto" }}
                    type="button"
                    variant="outline-primary"
                    size="sm"
                    className="float-right"
                    onClick={() => {
                      addUserToArray(u, true);
                      searchRef.current.focusInput();
                    }}
                  >
                    <FaTimes />
                  </Button>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </>
        )}
        {showMessages &&
          !submitting &&
          props.responseMessage &&
          props.responseMessage.status === 1 &&
          users.length > 0 && (
          <Alert variant={"success"}>{props.responseMessage.message}</Alert>
        )}
        {showMessages &&
          !submitting &&
          props.responseMessage &&
          props.responseMessage.status === 2 && (
          <Alert variant={"danger"}>{props.responseMessage.message}</Alert>
        )}
        {showMessages &&
          !submitting &&
          props.responseMessage &&
          props.responseMessage.status === 3 &&
          users.length <= 0 && (
          <>
            <br />
            <Alert variant={"danger"}>{props.responseMessage.message}</Alert>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {!submitting ? (
          <div style={{ width: "100%", display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
            <Button
              style={{ marginRight: '10px' }}
              type="button"
              onClick={(e) => props.onCancel(e, false)}
              variant="outline-secondary"
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="outline-primary"
              onClick={handleSubmit}
            >
              Save
            </Button>
          </div>
        ) : (
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        )}
      </Modal.Footer>
    </>
    // </Form>
  );
}
